import React from 'react';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import { Segment, Checkbox } from 'semantic-ui-react';
import Schema from './Schema';
import View from './View';

const Edit = (props) => {
  const { block, data, selected, onChangeBlock } = props;

  return (
    <>
      <View {...props} />
      <SidebarPortal selected={selected}>
        <>
          <BlockDataForm
            schema={Schema(props)}
            title="Image Carousel"
            formData={data}
            block={block}
            onChangeField={(id, value) => {
              onChangeBlock(block, {
                ...data,
                [id]: value,
              });
            }}
          />
          <Segment secondary attached>
            <div className="wrapper">
              <label
                htmlFor={`borderless-${block}`}
                style={{ display: 'block', marginBottom: '0.5rem' }}
              >
                Borderless carousel
              </label>
              <Checkbox
                id={`borderless-${block}`}
                toggle
                checked={!!data.borderless}
                onChange={(e, { checked }) => {
                  onChangeBlock(block, {
                    ...data,
                    borderless: checked,
                  });
                }}
              />
            </div>
          </Segment>
        </>
      </SidebarPortal>
    </>
  );
};

export default Edit;
